import { convertLegacyRouteRefs } from '@backstage/core-compat-api';
import {
  createComponentExtension,
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';
import { CreateAppRouteBinder } from '@backstage/frontend-app-api';

import { ExternalRoutes, Routes, rootRouteRef } from './routes';

export const surfacesPlugin = createPlugin({
  id: 'surfaces',
  routes: {
    ...Routes,
  },
  externalRoutes: {
    ...ExternalRoutes,
  },
});

export const bindSurfacesRoutes = (
  bind: CreateAppRouteBinder,
  extraRoutes?: Parameters<typeof convertLegacyRouteRefs>[0],
) => {
  bind(
    convertLegacyRouteRefs(surfacesPlugin.externalRoutes),
    convertLegacyRouteRefs({
      ...surfacesPlugin.routes,
      ...extraRoutes,
    }),
  );
};

export const ConfidenceSurfacesPage = surfacesPlugin.provide(
  createRoutableExtension({
    name: 'ConfidenceSurfacesPage',
    component: () =>
      import(
        /* webpackChunkName: "confidence-surfaces", webpackPrefetch: 10 */ './Router'
      ).then(m => m.Router),
    mountPoint: rootRouteRef,
  }),
);

export const ConfidenceSurfacesExtension = surfacesPlugin.provide(
  createComponentExtension({
    name: 'ConfidenceSurfacesExtension',
    component: {
      lazy: () =>
        import(
          /* webpackChunkName: "confidence-surfaces-extension", webpackPrefetch: 10 */ './Router'
        ).then(m => m.Router),
    },
  }),
);
